import { render } from "./Organ.vue?vue&type=template&id=5d014a92&scoped=true&lang=html"
import script from "./Organ.vue?vue&type=script&lang=js"
export * from "./Organ.vue?vue&type=script&lang=js"

import "./Organ.vue?vue&type=style&index=0&id=5d014a92&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d014a92"]])

export default __exports__